<script>
	import Permissions from '@/mixins/shared/permissions'
	import Translate from '@/helpers/Translate.js';

	export default {
		data() {
			return {
				placeholder: '',
				translation: '',
				loading: false,
			}
		},
		props: {
			display: {
				type: String,
				default: 'block',
			},
			hideEditButton: {
				type: Boolean,
				default: false,
			},
			identifier: {
				type: String,
				required: true,
			},
			replacements: {
				type: Object,
				default: {},
			},
			type: {
				type: String,
				default: 'html'
			},
			group: {
				type: String,
				default: 'algemeen',
			},
			languageCode: {
				type: String,
				default: 'nl',
			}
		},
		mixins: [Permissions],
		async mounted() {
			this.getPlaceholder();
			this.initTranslation();
		},
		methods: {
			getPlaceholder() {
				let placeholder = this.$refs.placeholder.innerHTML;
				if (placeholder.trim().length > 0) {
					this.placeholder = this.$refs.placeholder.innerHTML;
				} else {
					this.placeholder = this.identifier;
				}
				this.translation = this.placeholder;
				this.$refs.placeholder.remove();
			},

			initTranslation() {
				if (Translate.initialized) {
					this.getTranslation();
				}

				$(window).on('wwdev.translations.updated', async () => {
					this.getTranslation();
				});
			},

			async getTranslation() {
				if(this.loading) {
					return;
				}

				this.loading = true;
				if (!this.identifier) {
					console.error("Translation identifier is required");
					return this.placeholder;
				}
				let result = await Translate.getTranslation({
					default: this.placeholder,
					identifier: this.identifier,
					replacements: this.replacements,
					field_type: this.type,
					group: this.group,
					languageCode: this.languageCode,
				});
				
				this.translation = result;

				this.loading = false;

				return result;
			},

			edit() {
				$(window).trigger('wwdev.translations.edit', [this.identifier, this.group, this.type]);
			}
		}
	}
</script>

<template>
	<span v-bind="$attrs" :class="{'text-wrapper': true, 'ck-content' : type==='html'}" :style="`display: ${display};`">
		<template v-if="can('manage translations') && !hideEditButton">
			<div class="d-flex mb-3">
				<button @click.prevent="edit()" class="btn btn-success edit-text-button">
					<i class="bi bi-pencil-square"></i> <span class="btn-label">Tekst bewerken</span>
				</button>
			</div>
		</template>

		<div ref="placeholder" class="text">
			<slot></slot>
		</div>

		<template v-if="type === 'textarea'">
			<span class="text" style="white-space: pre-wrap;" v-html="translation"></span>
		</template>
		<template v-else>
			<span class="text" v-html="translation"></span>
		</template>
	</span>
</template>

<style scoped>
	.text-wrapper {
		outline-offset: 10px;
		outline: 2px solid transparent;
		transition: all .2s ease-in-out;
	}

	.text-wrapper:has(.edit-text-button:hover) {
		outline: 2px solid var(--bs-primary);
	}
</style>